import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'tppx-socialsearch',
  templateUrl: './socialsearch.component.html',
  styleUrls: ['./socialsearch.component.scss']
})
export class SocialsearchComponent implements OnInit {

  @Input() searchEnabled: boolean;
  public socialSearchForm: FormGroup;
  public IconFacebook="";
  public IconX="";

  constructor(private _formBuilder: FormBuilder) {
    this.createForm();
        this.IconFacebook = !window.location.origin.includes('https://www')? 
        "https://devnetx.miamidadepa.gov/CDN/"+environment.IconFacebook: `${environment.CDNPath}${environment.IconFacebook}`;
        
        this.IconX =!window.location.origin.includes('https://www')? 
        "https://devnetx.miamidadepa.gov/CDN/"+environment.IconX: `${environment.CDNPath}${environment.IconX}`;
  }

  ngOnInit() {
  }

  private createForm() {

    this.socialSearchForm = this._formBuilder.group({
      searchtext: [
        {
          value: '',
          disabled: false
        }
      ]
    });
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.onSearch();
    }
  }

  onSearch(): void {
    // const searchText = this._commonService.Trim(this.socialSearchForm.get("searchtext").value);
    // if (searchText) {
    //   window.open(`http://www.miamidadepa.gov/search/home.asp?q=${searchText}`);
    // }
  };

  public ShowPrint() {
    const url = window.location.href;
    return (url.includes('/business/'));
  }

  public onPrintClick() {
    // if (window.location.href.includes('/business/')) {
    //   this._folioService.SetSaveAsPDF(true);
    // } else {
    //   window.print();
    // }
  }

}
